const { useMemo } = require('react')

function useMemoOnce (value) {
  const memoized = useMemo(() => value, [])
  return memoized
}

export default useMemoOnce
